import { render, staticRenderFns } from "./video_switch_duration.vue?vue&type=template&id=0f190862&scoped=true"
import script from "./video_switch_duration.vue?vue&type=script&lang=ts"
export * from "./video_switch_duration.vue?vue&type=script&lang=ts"
import style0 from "./video_switch_duration.vue?vue&type=style&index=0&id=0f190862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f190862",
  null
  
)

export default component.exports